import { UserFile } from './FilesOverviewPage';
import styles from './FileLink.module.css';
import { getDownloadUrl } from '../../services/api/fileService';
import Button, { ButtonType } from '../general-components/Button';
import { Button as ButtonUI } from '../ui/button';
import {
    faArrowDown,
    faArrowUpRightFromSquare,
    faFile,
    faImage,
    faVideo,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// New FileLink component
const FileLink: React.FC<{
    file: UserFile;
    onClick: (file: UserFile) => void;
    buttonType?: string;
    disabled?: boolean;
    buttonText?: string;
    newTab?: boolean;
}> = ({
    file,
    onClick,
    buttonType = '',
    buttonText,
    disabled = false,
    newTab = false,
}) => {
    // Map document types to their respective icons
    const getFileIcon = (documentType: string, isButton = false) => {
        if (isButton) {
            if (newTab) {
                return <FontAwesomeIcon icon={faArrowUpRightFromSquare} />;
            }
            switch (documentType) {
                case 'document':
                    return <FontAwesomeIcon icon={faFile} />;
                case 'image':
                    return <FontAwesomeIcon icon={faImage} />;
                case 'video':
                    return <FontAwesomeIcon icon={faVideo} />;
                default:
                    return <FontAwesomeIcon icon={faFile} />;
            }
        } else {
            switch (documentType) {
                case 'document':
                    return <FontAwesomeIcon icon={faFile} />;
                case 'image':
                    return <FontAwesomeIcon icon={faImage} />;
                case 'video':
                    return <FontAwesomeIcon icon={faVideo} />;
                default:
                    return <FontAwesomeIcon icon={faFile} />;
            }
        }
    };

    const handleClick = async () => {
        if (
            (file?.expiry && file?.expiry < new Date().getTime()) ||
            !file.url
        ) {
            const newUrl = await getDownloadUrl(file._id);

            onClick({ ...file, url: newUrl });
        } else {
            onClick(file);
        }
    };

    return (
        <>
            <div className={styles.button}>
                {buttonType === 'action' && (
                    <Button
                        disabled={disabled}
                        value={file?.filename}
                        type={ButtonType.action}
                        onClick={handleClick}
                    >
                        {getFileIcon(file?.documentType, true)}{' '}
                        {buttonText ?? file?.filename}
                    </Button>
                )}
                {buttonType === 'shadcn' && (
                    <ButtonUI variant="outline" onClick={handleClick}>
                        {getFileIcon(file?.documentType, true)}{' '}
                        {buttonText ?? file?.filename}
                    </ButtonUI>
                )}
                {buttonType === 'compact' && (
                    <ButtonUI
                        variant="ghost"
                        onClick={handleClick}
                        className="h-8 justify-start px-2 text-sm font-normal text-muted-foreground hover:text-foreground"
                    >
                        {getFileIcon(file?.documentType, true)}{' '}
                        <span className="truncate">{buttonText ?? file?.filename}</span>
                    </ButtonUI>
                )}
            </div>
            {(buttonType === '' || buttonType === undefined) && (
                <div
                    style={{
                        display: 'flex',

                        alignItems: 'center',
                        width: '100%',
                        // gap: '5px',
                    }}
                >
                    <span style={{ flexShrink: 0 }}></span>
                    <a
                        className={styles.fileLink}
                        onClick={handleClick}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={file?.filename}
                        style={{ minWidth: 0, width: '100%' }}
                    >
                        <span className={styles.filename}>
                            {getFileIcon(file?.documentType)} {file?.filename}
                        </span>
                    </a>
                </div>
            )}
        </>
    );
};

export default FileLink;
